import React from 'react';
// Constants
import { KeywordsPages, LocationCity, MainTitle } from '../../utils/Constants';
// Data
import {
  testimonialsPageAdditionalMeta,
  testimonialsPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import TestimonialsPageMainContainer from '../../components/testimonials/TestimonialsPageMainContainer';
import GeneralHeader from '../../components/general/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';
// Images
import SammiMainImage from '../../assets/images/noBackground/mistress-sammmi-smith-gorgeous-smoking-small.png';
import TestimonialsHeaderImage from '../../assets/images/headers/testimonials-header-barbie-style.png';

function TestimonialsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Testimonials'
        desc={`Read firsthand experiences from those who have submitted to Mistress Sammi Smith in ${LocationCity}. Discover the depths of true devotion and the unforgettable encounters of those who have surrendered.`}
        keywords={KeywordsPages}
        additionalMeta={testimonialsPageAdditionalMeta}
        structuredData={testimonialsPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={TestimonialsHeaderImage}
            headerMobileImage={TestimonialsHeaderImage}
            mainTitle={`${MainTitle}`}
            subtitle={`Testimonials from happy subs`}
            mainImage={SammiMainImage}
          />
        </div>

        {/* Main page content */}
        <TestimonialsPageMainContainer />

        <FooterComponent />
      </div>
    </>
  );
}

export default TestimonialsPage;
